import React from "react";

export default function Chips(props) {
    return (
        <div className={"chips"}>
            {props.children}
        </div>
    )
}